module.exports = __webpack_public_path__ + "static/media/sf-test-1.d1cb17c3.mp3";